var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.542,
    cy: 11.817,
    r: 1.444
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9.834 19.957v-9.674a5.675 5.675 0 015.675-5.675h10.026l7.151 7.151v8.198"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.651 4.608v8.069h8.035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M6.12 24.743h30.279"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.681 29.118s2.011 5.363 6.369 6.369M27.055 37.912l6.108-1.454-1.6-5.09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M17.838 29.09s-2.011 5.363-6.369 6.369M15.465 37.884L9.357 36.43l1.6-5.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportXml);
export default __webpack_public_path__ + "static/media/exportXML.28c2aeaef9bb1f4f7d62cd774ddb08e0.svg";
export { ForwardRef as ReactComponent };